import { useEffect, useState } from 'react';
import {
  checkIdentity,
  getCachedIdentity,
  type IdentityState,
} from '@/core/identity-check';

export function useIdentityBlock(): IdentityState {
  const [state, setState] = useState<IdentityState>(
    () => getCachedIdentity() ?? { status: 'checking' }
  );
  useEffect(() => {
    let cancelled = false;
    void checkIdentity().then((next) => {
      if (!cancelled) setState(next);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return state;
}

export function activeBlockExpiresAt(state: IdentityState): string | undefined {
  if (state.status !== 'blocked' || !state.expiresAt) return undefined;
  return new Date(state.expiresAt).getTime() > Date.now()
    ? state.expiresAt
    : undefined;
}
